const Check = ({brandPrimaryColor}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="none" viewBox="0 0 24 24" strokeWidth="1" stroke={brandPrimaryColor ? brandPrimaryColor : '#000000'} className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>

    )
}

export default Check;